<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Consultar Fatura</v-toolbar-title>
      </v-toolbar>
      <div class="row align-center" style="max-width: 600px; margin: 20px auto">
        <div class="col">
          <v-text-field
            label="Id da Fatura"
            v-model="invoiceId"
            type="text"
            outlined dense hide-details
          ></v-text-field>
        </div>
        <div class="col-auto">
          <v-btn color="primary" :disabled="!invoiceId" @click="getData">
            <v-icon left>mdi-magnify</v-icon> Consultar
          </v-btn>
        </div>
      </div>
      <template v-if="invoiceData">
        <v-divider />
        <div class="row">
          <div class="col-12 col-sm">
            <div class="py-3">
              <small><b>Produto</b></small><br/>
              {{ invoiceData.product_reference | product_reference }}
            </div>
            <div class="py-3">
              <small><b>{{ invoiceData.product_reference | product_reference }}</b></small><br/>
              {{ invoiceData.account.name }}
            </div>
            <div class="py-3">
              <small><b>Conta Heppi</b></small><br/>
              {{ invoiceData.account.account_number }}
            </div>
            <div class="py-3">
              <small><b>CPF/CNPJ</b></small><br/>
              {{ invoiceData.account.owner.document | document }}
            </div>
          </div>
          <div class="col-12 col-sm">
            <div class="py-3">
              <small><b>Cliente</b></small><br/>
              {{ invoiceData.customer.name }}
            </div>
            <div class="py-3">
              <small><b>CPF/CNPJ</b></small><br/>
              {{ invoiceData.customer.document | document }}
            </div>
            <div class="py-3">
              <small><b>Telefone</b></small><br/>
              {{ invoiceData.customer.phone_number | phone_number }}
            </div>
            <div class="py-3">
              <small><b>E-mail</b></small><br/>
              {{ invoiceData.customer.email }}
            </div>
          </div>
          <div class="col-12 col-sm">
            <div class="py-3">
              <small><b>Status</b></small><br/>
              {{ invoiceData.invoice_status | invoice_status }}
            </div>
            <div class="py-3">
              <small><b>Competência</b></small><br/>
              {{ invoiceData.invoice_date | moment('MMMM YYYY') }}
            </div>
            <div class="py-3">
              <small><b>Vencimento</b></small><br/>
              {{ invoiceData.due_date | moment('DD/MM/YYYY') }}
            </div>
            <div v-if="invoiceData.product_reference === 'fundraising'" class="py-3">
              <small><b>Link no suporte</b></small><br/>
              <router-link :to="{ name: 'invoiceDetails', params: { id: invoiceData.external_reference } }">Abrir fatura</router-link>
            </div>
            <div v-else class="py-3">
              <small><b>Link da fatura</b></small><br/>
              <a :href="invoiceData.invoice_url" target="_blank">Abrir fatura</a>
            </div>
          </div>
        </div>
        <template v-if="invoiceData.invoice_status === 'paid'">
          <h3 class="mt-6 py-3">Dados do pagamento</h3>
          <div class="row" v-if="invoiceData.fee_applied && invoiceData.fee_applied.fee">
            <div class="col-12 col-sm">
              <div>
                <small><b>Total Pago</b></small><br/>
                {{ invoiceData.total_amount | price }}
              </div>
            </div>
            <div class="col-12 col-sm">
              <div>
                <small><b>Forma de Pagamento</b></small><br/>
                {{ invoiceData.fee_applied.fee.type | fee_type }}
              </div>
            </div>
            <div class="col-12 col-sm">
              <div>
                <small><b>Taxa Heppi</b></small><br/>
                <div v-if="invoiceData.fee_applied.fee.method === 'tax'">
                  {{ invoiceData.fee_applied.fee.fee | price }} ({{ invoiceData.fee_applied.fee.processing_mode | fee_type }})
                </div>
                <div v-else-if="invoiceData.fee_applied.fee.method === 'percent'">
                  {{ invoiceData.fee_applied.fee.fee }}% ({{ invoiceData.fee_applied.fee.processing_mode | fee_type }})
                </div>
              </div>
            </div>
            <div class="col-12 col-sm">
              <div v-if="invoiceData.fee_applied.fee.type === 'credit_card'">
                <small><b>Parcelas</b></small><br/>
                {{ invoiceData.fee_applied.fee.installment }}
              </div>
            </div>
          </div>
        </template>
        <template v-if="invoiceData.fee_applied && invoiceData.fee_applied.credit_card && invoiceData.fee_applied.fee.type === 'credit_card'">
          <h3 class="mt-6 py-3">Último cartão usado</h3>
          <div class="row" v-if="invoiceData.fee_applied && invoiceData.fee_applied.fee">
            <div class="col-12 col-sm">
              <div>
                <small><b>Cartão</b></small><br/>
                {{ invoiceData.fee_applied.credit_card.payment_method_id }}: {{ invoiceData.fee_applied.credit_card.first_six_digits }} **** {{ invoiceData.fee_applied.credit_card.last_four_digits }}
              </div>
            </div>
            <div class="col-12 col-sm">
              <div>
                <small><b>Data de expiração</b></small><br/>
                {{ invoiceData.fee_applied.credit_card.expiration_month > 9 ? invoiceData.fee_applied.credit_card.expiration_month : '0' + invoiceData.fee_applied.credit_card.expiration_month }}/{{ invoiceData.fee_applied.credit_card.expiration_year }}
              </div>
            </div>
            <div class="col-12 col-sm">
              <div>
                <small><b>Titular do Cartão</b></small><br/>
                {{ invoiceData.fee_applied.credit_card.identification_name }}
              </div>
            </div>
          </div>
        </template>
        <template v-if="invoiceData.gateway_responses">
          <h3 class="mt-6 py-3">Respostas do gateway</h3>
          <div class="row" v-for="response in invoiceData.gateway_responses" :key="response.id">
            <div class="col-12 col-sm">
              <div>
                <small><b>Operação MP</b></small><br/>
                {{ response.id }}
              </div>
            </div>
            <div class="col-12 col-sm">
              <div>
                <small><b>Status</b></small><br/>
                {{ response.status | mp_status }}
              </div>
            </div>
            <div class="col-12 col-sm">
              <div>
                <small><b>Forma de pagamento</b></small><br/>
                {{ response.payment_type === 'ticket' ? 'Boleto' : 'Cartão (' + response.installments + 'x)' }}
              </div>
            </div>
            <div class="col-12 col-sm">
              <div>
                <small><b>Data de criação</b></small><br/>
                {{ response.date_created | moment('DD/MM/YYYY HH:mm') }}
              </div>
            </div>
            <div v-if="response.payment_type === 'ticket' && !response.date_approved" class="col-12 col-sm">
              <div>
                <small><b>Data de expiração</b></small><br/>
                {{ response.date_of_expiration | moment('DD/MM/YYYY HH:mm') }}
              </div>
            </div>
            <div v-else class="col-12 col-sm">
              <div>
                <small><b>Data de Aprovação</b></small><br/>
                {{ response.date_approved | moment('DD/MM/YYYY HH:mm') }}
              </div>
            </div>
            <div v-if="response.status === 'pending' && response.transaction.external_resource_url" class="col-12">
              <div>
                <small><b>Link do boleto</b></small><br/>
                <a :href="response.transaction.external_resource_url" target="_blank">{{ response.transaction.external_resource_url }}</a>
              </div>
            </div>
            <div v-else-if="response.transaction && response.transaction.verification_code" class="col-12">
              <div>
                <small><b>Código de verificação</b></small><br/>
                {{ response.transaction.verification_code }}
              </div>
            </div>
            <div v-if="response.status === 'rejected'" class="col-12">
              <div>
                <small><b>Motivo da recusa</b></small><br/>
                <template v-if="['cc_rejected_bad_filled_card_number', 'cc_rejected_bad_filled_date', 'cc_rejected_bad_filled_other', 'cc_rejected_bad_filled_security_code'].includes(response.status_detail)">
                  Os dados enviados estão incorretos
                </template>
                <template v-else-if="['cc_rejected_call_for_authorize'].includes(response.status_detail)">
                  O cliente precisa ligar para o banco para autorizar o pagamento
                </template>
                <template v-else-if="['cc_rejected_insufficient_amount'].includes(response.status_detail)">
                  Saldo insuficiente
                </template>
                <template v-else-if="['cc_rejected_invalid_installments'].includes(response.status_detail)">
                  O cartão não aceita essa quantidade de parcelas
                </template>
                <template v-else-if="['cc_rejected_high_risk'].includes(response.status_detail)">
                  Pagamento foi recusado porque não passou pelos controles de segurança do Mercado Pago. Peça para seu cliente usar outro cartão. Indicadores de risco:
                  <ul>
                    <li>O documento não possui pagamentos confiáveis associados a ele.</li>
                    <li>Mais de 80% dos pagamentos aprovados nos últimos 90 dias foram feitos na última semana por este usuário.</li>
                    <li>O documento não possui pagamentos confiáveis associados a este cartão.</li>
                  </ul>
                </template>
                <template v-else>
                  Pagamento recusado pelo banco
                </template>
              </div>
            </div>
            <div class="col-12 px-6">
              <v-divider />
            </div>
          </div>
        </template>
      </template>
    </v-container>
  </v-main>
</template>

<script>
import { mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'invoiceConsult',
  data: () => ({
    loading: false,
    invoiceId: '',
    invoiceData: null
  }),
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    getData () {
      let vue = this
      vue.loading = true

      axios.get('invoices/' + vue.invoiceId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        .then(response => {
          if (response.data) {
            vue.loading = false
            vue.invoiceData = response.data
          } else {
            vue.loading = false
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            vue.invoiceData = null
          }
        })
        .catch(() => {
          vue.loading = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.invoiceData = null
        })
    }
  }
}
</script>
